<template>
  <div>
    <v-toolbar color="grey lighten-3">
      <v-toolbar-title>{{ $t('Give {0}', [$t('Free Samples').toLowerCase()]) }}</v-toolbar-title>
    </v-toolbar>
    <v-card
      class="pt-3"
      tile
    >
      <v-card-text>
        <form-wrapper :validator="$v.form">
          <v-form
            ref="form"
            @submit.prevent="submit"
          >
            <h3 class="text-center mb-5">{{ $t('How many items should be given as sample?') }}</h3>
            <form-group name="quantity">
              <template v-slot:default="{ attrs }">
                <numeric-keyboard
                  ref="keyboard"
                  :keyboard-class="`keyboardSamples-${receiptProduct.uuid}`"
                  :layout="[`1 2 3`, `4 5 6`, `7 8 9`, `0 {clear}`]"
                  @clear="clear"
                  @input="input"
                >
                  <v-text-field
                    ref="input"
                    slot="input"
                    slot-scope="{ setKeyboardInput }"
                    v-bind="attrs"
                    v-model="form.quantity"
                    :label="$t('Quantity')"
                    autocomplete="off"
                    filled
                    hide-details
                    @blur="$v.form.quantity.$touch()"
                    @input="setKeyboardInput($event);$v.form.quantity.$touch()"
                  />
                </numeric-keyboard>
              </template>
            </form-group>
            <v-slide-y-transition>
              <p
                v-show="errorMessage"
                class="red--text mb-0 mt-4 text-center"
              > {{ errorMessage }} </p>
            </v-slide-y-transition>
          </v-form>
        </form-wrapper>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          :loading="$wait.is(`saving samples ${receiptProduct.uuid}`)"
          class="font-weight-bold"
          color="primary"
          text
          @click="submit"
        > {{ $t('Save') }} </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import NumericKeyboard from '@/components/NumericKeyboard'
import { required, numeric, minValue } from 'vuelidate/lib/validators'
import validationMixin from '@/utils/mixins/validationMixin'

export default {
  name: 'FormsSamplesSave',

  components: {
    NumericKeyboard
  },

  mixins: [ validationMixin ],

  props: {
    receiptProductObject: {
      type: Object,
      required: true
    },
    clearInput: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: () => ({
    errorMessage: '',
    form: {
      quantity: null
    },
    receiptProduct: null
  }),

  validations () {
    return {
      form: {
        quantity: {
          required,
          numeric,
          minValue: minValue(1)
        }
      }
    }
  },

  watch: {
    receiptProductObject: {
      immediate: true,
      handler (receiptProductObject) {
        this.receiptProduct = Object.assign({}, receiptProductObject)
      }
    },
    clearInput: {
      handler (val) {
        if (val) {
          this.clear()
        }
      }
    }
  },

  mounted () {
    // Put error messages in separate reactive data property
    this.$watch(
      () => this.$refs['input'].errorMessages,
      (messages) => {
        this.errorMessage = messages.length ? messages[0] : ''
      }
    )
  },

  methods: {
    submit () {
      if (!this.validate()) return
      this.$wait.start(`saving samples ${this.receiptProduct.uuid}`)
      return this.$store.dispatch('RECEIPT/CHANGE_SAMPLE_QUANTITY', { receiptProductUuid: this.receiptProduct.uuid, qty: parseInt(this.form.quantity) })
        .then(data => {
          this.helpers.toastSuccess(data.message)
          this.$emit('saved', this.receiptProduct)
        })
        .catch(data => { if (data && data.message) this.helpers.toastError(data.message) })
        .finally(() => this.$wait.end(`saving samples ${this.receiptProduct.uuid}`))
    },
    input (input) {
      this.form.quantity = input
    },
    clear () {
      this.form.quantity = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/discounts/FormsSamplesSave.vue